var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.14612C0 1.5135 0.529625 1 1.1825 1H14.8175C15.4706 1 16 1.5135 16 2.14612V15.8541C16 16.4869 15.4706 17 14.8175 17H1.1825C0.529688 17 0 16.4869 0 15.8542V2.14594V2.14612Z",
    fill: "#006699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86228 14.39V7.18673H2.46803V14.39H4.86253H4.86228ZM3.66565 6.20342C4.5004 6.20342 5.02009 5.65029 5.02009 4.95904C5.00447 4.25204 4.5004 3.71436 3.68153 3.71436C2.86209 3.71436 2.3269 4.25204 2.3269 4.95898C2.3269 5.65023 2.8464 6.20336 3.64997 6.20336H3.66547L3.66565 6.20342ZM6.18753 14.39H8.58159V10.3678C8.58159 10.1528 8.59722 9.93723 8.66047 9.78367C8.83347 9.35336 9.22741 8.90792 9.88897 8.90792C10.7551 8.90792 11.1018 9.56842 11.1018 10.5369V14.39H13.4958V10.2599C13.4958 8.04742 12.3148 7.01786 10.7396 7.01786C9.44815 7.01786 8.88097 7.73967 8.56584 8.23129H8.58178V7.18698H6.18765C6.2189 7.86273 6.18747 14.3902 6.18747 14.3902L6.18753 14.39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f52158c17a1181a3ccc61976cd89a216.svg";
export { ForwardRef as ReactComponent };